<template>
  <v-app
	:dark="darkMode"
	id="inspire"
	:class="[{ 
		'box-layout': boxLayout,
		'rtl-layout': rtlLayout
	}]"
  >
	  <router-view></router-view>
	  <snackbar></snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      animation: {
        enter: {
          opacity: [1, 0],
          translateX: [0, -300],
          scale: [1, 0.2]
        },
        leave: {
          opacity: 0,
          height: 0
        }
     }
    }
  },
  computed: {
    ...mapGetters([
      'darkMode',
      'boxLayout',
      'rtlLayout',
      'selectedLocale'
    ])
  }
}
</script>
<style>
    .v-list-tile-pl0 > .v-list__tile {
        padding-left: 0 !important;
    }

	.truncate-content {
		contain: size !important;
	}

	/* badge cantidad de tecnología en prescripciones */
	.badge-cantidad-tecnologia>span.v-badge__badge {
		height: 20px !important;
		width: 20px !important;
		font-size: 12px !important;
		left: 34px !important;
	}
	.px0-vtoolbar>.v-toolbar__content {
		padding: 0px !important;
	}
</style>